<div class="custom-image-calibration-dialog">
  <div class="dialog-content">
    <span class="instruction-text" [innerHTML]="'design.customImage.calibration.selectPointsInstruction' | translate"></span>
    
    <div class="input-group">
      <div class="distance-input-wrapper" [class.active]="pointsCount >= 2">
        <input #distanceInput
               type="number" 
               class="distance-input"
               [value]="displayValue"
               placeholder="--"
               min="0"
               step="0.1"
               [disabled]="pointsCount < 2"
               (focus)="onInputFocus($event)"
               (blur)="onInputBlur($event)"
               (input)="onInputChange($event)"
               (keydown.enter)="onConfirm()">
        <span class="unit-label">{{ selectedUnit }}</span>
      </div>
    </div>

    <div class="action-buttons">
      <button mat-icon-button 
              class="confirm-btn" 
              type="button" 
              (click)="onConfirm()"
              [disabled]="!isValid()">
        <mat-icon>check</mat-icon>
      </button>
      <button mat-icon-button 
              class="cancel-btn" 
              type="button" 
              (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
